var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1629096302030,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 3123,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M938 550.1l-404.1 233c-13.6 7.8-30.3 7.8-43.8 0L86 550.1c-29.4-16.9-29.4-59.3 0-76.3l404.1-233c13.6-7.8 30.3-7.8 43.8 0l404.1 233c29.3 17 29.3 59.4 0 76.3z",
    "p-id": 3124
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneLayer);
export default __webpack_public_path__ + "static/media/oneLayer.a98ab7cf1f07cc1c8facfca6d6e62392.svg";
export { ForwardRef as ReactComponent };